import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getMessaging, onMessage } from "@firebase/messaging";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import LoginPage from "./ui/login/PageLogin";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./res/theme/typopgraphy.css";
import LayoutComponent from "./ui/home/LayoutComponent";
import HomePage from "./ui/home/HomePage";
import { useEffect, useRef } from "react";
import { eventEmitter } from "./tools/EventEmitter";
import VisitorPage from "./ui/other/VisitorPage";
import CalendarPage from "./ui/home/CalendarPage";
import PreferencesPage from "./ui/home/Preferences";
import ManagePage from "./ui/home/ManagePage";
import NotFoundPage from "./ui/other/NotFound";
import TutorialPage from "./ui/home/TutorialPage";
import TutorialExplainPage from "./ui/home/tutorial/TutorialExplainPage";
import BookedPage from "./ui/settings/BookedPage";
import ProfileSettingsPage from "./ui/settings/ProfileSettingsPage";
import InternalNotificationComponent from "./ui/components/dialog/InternalNotification";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyC4ChuiPKaI1eQmcnH3eMjkK4MifQWOyXo",
	authDomain: "corzoneso-baae0.firebaseapp.com",
	projectId: "corzoneso-baae0",
	storageBucket: "corzoneso-baae0.firebasestorage.app",
	messagingSenderId: "140315163142",
	appId: "1:140315163142:web:73d6b0dd9dfae165272187",
	measurementId: "G-9V4HLPGRZ2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);

export let userData = null;

async function loadUserData(uid) {
	const docRef = doc(firestore, "users", uid);
	const docSnap = await getDoc(docRef);

	if (docSnap.exists()) {
		return docSnap.data();
	}
	return null;
}

const routes = createBrowserRouter([
	{
		path: "/",
		element: <div></div>,
	},
	{
		path: "/app",
		element: <LayoutComponent />,
		children: [
			{
				index: true,
				element: <HomePage />,
			},
			{
				path: "/app/calendario",
				element: <CalendarPage />,
			},
			{
				path: "/app/gestione",
				element: <ManagePage />,
			},
			{
				path: "/app/tutorial",
				element: <TutorialPage />,
			},
			{
				path: "/app/tutorial/:tutorialId",
				element: <TutorialExplainPage />,
			},
			{
				path: "/app/impostazioni",
				element: <PreferencesPage />,
			},
			{
				path: "/app/impostazioni/profilo",
				element: <ProfileSettingsPage />,
			},
			{
				path: "/app/prenotazioni/:userId",
				element: <BookedPage />,
			},
		],
	},
	{
		path: "/login",
		element: <LoginPage auth={auth} />,
	},
	{
		path: "/visitatore",
		element: <VisitorPage />,
	},
	{
		path: "*",
		element: <NotFoundPage />,
	},
]);

function App() {
	const internalNotificationRef = useRef(null);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
			console.log(currentUser);

			if (currentUser && userData == null) {
				userData = await loadUserData(currentUser.uid);
				console.log("user loaded", userData);
				eventEmitter.emit("userDataUpdated", userData);
			}

			const currentPath = window.location.pathname;

			if (currentUser) {
				if (currentPath === "/" || currentPath === "/login") {
					window.open("/app", "_self");
				}
			} else {
				if (currentPath === "/" || currentPath === "/app") {
					window.open("/login", "_self");
				}
			}
		});

		return unsubscribe;
	}, [auth]);

    useEffect(() => {
        const handleShowNotification = (data) => {
            if (internalNotificationRef.current) {
                internalNotificationRef.current.show({
                    title: data.title || "",
                    text: data.text || "",
                });
            }
        };

        eventEmitter.on("showNotification", handleShowNotification);

        return () => {
            eventEmitter.off("showNotification", handleShowNotification);
        };
    }, []);

	onMessage(messaging, (payload) => {
		console.log("Message received. ", payload);
        if (payload.notification) {
            eventEmitter.emit("showNotification", {
                title: payload.notification.title,
                text: payload.notification.body,
            });
		}
	});

	return (
		<>
			<RouterProvider router={routes} />
			<InternalNotificationComponent ref={internalNotificationRef} />
		</>
	);
}

export default App;
